import { invalidationTypeApi } from "../../api";

const InvalidationTypeService = {
  fetchDropdown: async () => {
    const response = await invalidationTypeApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default InvalidationTypeService;
